import React, { createContext, useContext } from 'react';

import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { Button, useTheme } from '@mui/material';

import { AskRichardWordmark } from '~/components/brand';

export const OpenPageChat = createContext<(() => void) | null>(null);

export default function PageChatButton() {
  const open = useContext(OpenPageChat);
  const theme = useTheme();
  if (!open) return null;
  return (
    <Button
      aria-label="Open askRichard panel"
      variant="outlined"
      size="small"
      startIcon={<AutoAwesomeOutlinedIcon fontSize="small" />}
      onClick={open}
      sx={{ flexShrink: 0, textTransform: 'none' }}
    >
      <AskRichardWordmark inverted={theme.palette.mode === 'dark'} size={14} />
    </Button>
  );
}
